export default __webpack_public_path__ + "static/media/gp_1.991d73ee.jpg";